import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

export default {
  actions: {
    async [actionTypes.DO_GET_BELIEF_STATEMENTS]({ commit }, params) {
      const { data } = await HTTP.get('/belief_statements', { params });
      commit(mutationTypes.SET_BELIEF_STATEMENTS, data.data.belief_statements);
      return data;
    },
  },
  getters: {
    [getterTypes.GET_BELIEF_STATEMENTS]: state => state.statements,
  },
  mutations: {
    [mutationTypes.SET_BELIEF_STATEMENTS](state, statements) {
      state.statements = statements;
    },
  },
  state: {
    statements: [],
  },
};
